import { useContext } from 'react';

import { web3Context } from './Web3Provider';

export const useWeb3 = () => {
  return useContext(web3Context);
};
